import React from 'react';
import { FadeIn } from './FadeIn';
export function Mechanism() {
  return <section className="py-24 px-6 bg-sage/10" data-id="element-130">
      <div className="max-w-3xl mx-auto text-center" data-id="element-131">
        <FadeIn data-id="element-132">
          <span className="text-coral font-bold tracking-wider uppercase text-sm mb-4 block" data-id="element-133">
            The Unique Mechanism
          </span>
          <h2 className="text-3xl md:text-4xl text-teal mb-8" data-id="element-134">
            The "Cool-Down" Protocol
          </h2>

          <div className="bg-white p-8 md:p-12 rounded-2xl shadow-sm" data-id="element-135">
            <p className="text-lg text-charcoal/80 leading-relaxed mb-6" data-id="element-136">
              This isn't a long-term lifestyle overhaul. It is a tactical, 7-day
              anti-inflammatory strike.
            </p>
            <p className="text-lg text-charcoal/80 leading-relaxed" data-id="element-137">
              We use a specific sequence of "Hormonal Anchors"—targeted
              nutrients and minerals—that tell your brain's thermostat to stop
              panicking. By lowering the "heat" at a cellular level, we stop the
              flare before it even starts.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}